import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { RadioGroupFieldWUT } from '../../../ui/radio-group-field';
export const EventsRsvpWUT = props => {
  const {
    fieldType = FIELD_TYPES.EVENTS_RSVP
  } = props;
  return /*#__PURE__*/React.createElement(RadioGroupFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    hideLabel: true
  }));
};
//# sourceMappingURL=events-rsvp-wut.js.map